export enum AppointmentSource {
  BUSINESS_SITE = 'business_site', // Customer self-booked on the website
  ADMIN = 'admin',                  // Business owner booked manually in the dashboard
  WHATSAPP_BOT = 'whatsapp_bot',   // WhatsApp AI bot booked on behalf of the customer
  ADMIN_BOT = 'admin_bot',          // Admin voice/text AI bot booked
  SMART_NUDGE = 'smart_nudge',     // Customer booked via Smart Nudge message link
}
